import classNames from 'classnames';
import { ReactComponentLike } from 'prop-types';
import React from 'react';
import { Check } from '~svg-components';
import styles from './list-item.module.scss';
interface ListItemProps {
  tag?: ReactComponentLike;
  className?: string;
  isSelected?: boolean;
  onClick?: (e: React.MouseEvent<any>) => void;
}

const ListItem = React.forwardRef<any, ListItemProps & React.HTMLAttributes<any>>((props, ref) => {
  const { tag: Tag = 'li', className, isSelected, children, ...otherProps } = props;
  return (
    <>
      <Tag ref={ref} {...otherProps} className={classNames(styles.root, className)}>
        {children}
        {isSelected && <Check className={styles.selected} />}
      </Tag>
    </>
  );
});

export default ListItem;
